<template>
  <div class="site-device-main">
    <!-- 搜索排序 -->
    <div class="site-device-action">
      <div class="site-device-action-content">
        <div class="site-device-search">
          <a-input
            :placeholder="$t('device_search_keyword_placeholder')"
            v-model="searchKeyword"
            @change="filterDevicesByName"
            allowClear
          />
          <a-button type="primary" @click="filterDevicesByName">
            {{ $t('com_btn_lookfor') }}
          </a-button>
          <a-button type="default" @click="resetSearch">{{ $t('com_btn_reset') }}</a-button>
        </div>
        <div class="site-device-sort">
          <span :class="listType === 'card' ? 'active' : ''" @click="listTypeHandle('card')">
            <Icon type="menu"
          /></span>
          <span :class="listType === 'list' ? 'active' : ''" @click="listTypeHandle('list')">
            <Icon type="list" />
          </span>
        </div>
      </div>
    </div>

    <!-- 内容 -->
    <div class="site-device-content">
      <div class="site-device-content-title">
        <router-link
          :to="{
            name: 'DeviceAdd',
            query: { siteId: stationId },
          }"
          v-if="AUTH_DEVICE_ADD"
        >
          <!-- 添加设备 -->
          <a-button type="primary" icon="plus">
            {{ $t('com_btn_add_device') }}
          </a-button>
        </router-link>

        <!-- 导入设备 -->
        <a-button
          type="default"
          icon="download"
          style="margin-left: 10px;"
          @click="
            e => {
              this.showImport = true;
              e.stopPropagation();
            }
          "
          v-if="AUTH_SITE_DETAIL_DEVICE_BATCH_IMPORT"
        >
          {{ $t('device_table_import') }}
        </a-button>
      </div>
      <div class="site-device-content-list" v-if="deviceList && deviceList.length > 0">
        <!-- Card -->
        <ul v-if="listType === 'card'" class="site-device-content-card">
          <li v-for="item in deviceList" :key="item.devId">
            <div class="card-title">
              <router-link
                :to="{
                  name: 'DeviceDetail',
                  params: { id: item.devId },
                }"
                :title="item.name"
                v-if="AUTH_DEVICE_DETAIL"
              >
                <a-tooltip placement="top" :title="item.name">
                  {{ item.name }}
                </a-tooltip>
              </router-link>
              <a-tooltip placement="top" :title="item.name" v-else>
                <span>{{ item.name }}</span>
              </a-tooltip>
            </div>
            <div class="card-content">
              <dl class="card-content-time">
                <dd>
                  <strong>
                    {{
                      calculateDuration({
                        time: item.instDate,
                        showDay: true,
                        showHour: false,
                        showMin: false,
                      })
                    }}
                  </strong>
                  <span>{{ $t('device_table_total_runtime') }}</span>
                </dd>
                <dd>
                  <!-- 当前时间 - 最后维护的时间 -->
                  <strong>
                    {{
                      calculateDuration({
                        time: item.maintenanceUpdtTime,
                        showDay: true,
                        showHour: false,
                        showMin: false,
                      })
                    }}
                  </strong>
                  <span>{{ $t('device_table_unmaintained_time') }}</span>
                </dd>
              </dl>
              <p>
                <label>{{ $t('device_table_sn') }}：</label><span>{{ item.devSn }}</span>
              </p>
              <p>
                <label>{{ $t('device_table_model') }}：</label
                ><span>
                  {{
                    item.devModelAliasName ||
                      (modelAliasObject && modelAliasObject[item.devModelId]
                        ? modelAliasObject[item.devModelId]
                        : item.modelName)
                  }}
                </span>
              </p>
              <p>
                <label>{{ $t('device_table_soft_version') }}：</label
                ><span>{{ item.versionInfo }}</span>
              </p>
              <p>
                <label>{{ $t('device_table_install_date') }}：</label
                ><span>{{ item.instDate | formatDate('yyyy-MM-dd') }}</span>
              </p>
              <p>
                <label>{{ $t('device_table_status') }}：</label>
                <span>
                  <!-- 状态 -->
                  <DeviceStatus
                    :onlineStatus="item.onlineStatus"
                    :faultStatus="item.faultStatus"
                    :workStatus="item.workStatus"
                    :vpnStatus="item.vpnStatus"
                    :disabledStatus="item.disable"
                  />
                </span>
              </p>
            </div>
            <div class="card-action">
              <dl>
                <!-- 编辑 -->
                <dd v-if="AUTH_DEVICE_EDIT">
                  <router-link
                    :to="{
                      name: 'DeviceUpdate',
                      params: { id: item.devId },
                    }"
                  >
                    <Icon type="edit2" />
                  </router-link>
                </dd>
                <!-- 维护 -->
                <dd v-if="AUTH_DEVICE_MAINTENANCE">
                  <a href="javascript:;" @click="handleMaintenance(item)">
                    <Icon type="tool" />
                  </a>
                </dd>
                <dd v-if="AUTH_DEVICE_DELETE || AUTH_DEVICE_ENABLE_DISABLE">
                  <a-popover
                    trigger="hover"
                    overlayClassName="custom-popover-menu custom-popover-noarrow"
                  >
                    <template slot="content">
                      <ul class="g-ellipsis-menu">
                        <!-- 已禁用，显示启用 -->
                        <li
                          @click="enableDevice(item)"
                          v-if="item.disable === true && AUTH_DEVICE_ENABLE_DISABLE"
                        >
                          <ins><a-icon type="play-circle"/></ins>
                          <span>{{ $t('com_btn_enabled2') }}</span>
                        </li>

                        <li
                          @click="disabledDevice(item)"
                          v-if="item.disable === false && AUTH_DEVICE_ENABLE_DISABLE"
                        >
                          <ins><Icon type="forbidden2"/></ins>
                          <span>{{ $t('com_btn_disabled2') }}</span>
                        </li>

                        <li
                          @click="deleteDevice(item)"
                          class="site-device-delete"
                          v-if="AUTH_DEVICE_DELETE"
                        >
                          <ins><Icon type="delete"/></ins>
                          <span>{{ $t('com_btn_delete') }}</span>
                        </li>
                      </ul>
                    </template>
                    <a href="javascript:;">
                      <Icon type="ellipsis" />
                    </a>
                  </a-popover>
                </dd>
              </dl>
            </div>
          </li>
        </ul>

        <!-- List -->
        <div class="site-device-content-list g-table" v-else>
          <a-table
            :columns="columns"
            :data-source="deviceList"
            :pagination="false"
            :rowKey="(text, index) => text.devId"
            bordered
          >
            <!-- 名称 -->
            <!-- <template slot="Name" slot-scope="text, record">
              <router-link
                :to="{
                  name: 'DeviceDetail',
                  params: { id: record.devId },
                }"
                v-if="AUTH_DEVICE_DETAIL"
                style="display: flex; align-items: center;"
              >
                <DeviceAvatar :avatarType="record.avatar" />
                {{ text }}
              </router-link>
              <span v-else>
                {{ text }}
              </span>
            </template> -->
            <!-- 名称 -->
            <template slot="Name" slot-scope="text, record">
              <div class="device-list-name">
                <div class="device-list-name-icon">
                  <DeviceAvatar :avatarType="record.avatar" />
                </div>
                <div class="device-list-name-link">
                  <router-link
                    :to="{
                      name: 'DeviceDetail',
                      params: { id: record.devId },
                    }"
                    v-if="AUTH_DEVICE_DETAIL"
                  >
                    <span>{{ text }}</span>
                  </router-link>
                  <span v-else>
                    {{ text }}
                  </span>
                </div>
                <!-- <a-tooltip :getPopupContainer="triggerNode => triggerNode.parentNode">
                    <template slot="title">{{ $t('device_name_copy') }}</template>
                    <a-icon
                      type="copy"
                      data-clipboard-action="copy"
                      title="Copy"
                      style="color:#ccc"
                      :data-clipboard-text="`${text}`"
                      :id="`device_list_copy_${record.id}`"
                      @click="copyContent(`#device_list_copy_${record.id}`)"
                    />
                  </a-tooltip> -->
              </div>
            </template>

            <!-- 版本 -->
            <template slot="versionInfo" slot-scope="text">
              <div class="g-table-text">
                {{ text }}
              </div>
            </template>

            <!-- SN -->
            <template slot="devSn" slot-scope="text">
              <div class="g-table-text">
                {{ text }}
              </div>
            </template>

            <!-- Model -->
            <template slot="modelName" slot-scope="text, record">
              <div class="g-table-text">
                {{
                  record.devModelAliasName ||
                    (modelAliasObject && modelAliasObject[record.devModelId]
                      ? modelAliasObject[record.devModelId]
                      : text)
                }}
              </div>
            </template>

            <!-- 时间 -->
            <template slot="InstDate" slot-scope="text">
              {{ text | formatDate('yyyy-MM-dd') }}
            </template>

            <!-- 状态 -->
            <template slot="Status" slot-scope="text, record">
              <DeviceStatus
                :onlineStatus="record.onlineStatus"
                :faultStatus="record.faultStatus"
                :workStatus="record.workStatus"
                :vpnStatus="record.vpnStatus"
                :disabledStatus="record.disable"
              />
            </template>

            <!-- 操作 -->
            <template slot="Action" slot-scope="text, record">
              <div class="site-device-action">
                <!-- 编辑 -->
                <router-link
                  :to="{
                    name: 'DeviceUpdate',
                    params: { id: record.devId },
                  }"
                  class="g-btn-link-icon"
                  v-if="AUTH_DEVICE_EDIT"
                >
                  <a-button type="primary">
                    <Icon type="edit2" />
                  </a-button>
                </router-link>

                <!-- 维护 -->
                <a-button
                  type="primary"
                  v-if="AUTH_DEVICE_MAINTENANCE"
                  class="g-btn-icon"
                  @click="handleMaintenance(record)"
                >
                  <Icon type="tool" />
                </a-button>

                <a-popover
                  trigger="hover"
                  placement="bottom"
                  overlayClassName="custom-popover-menu custom-popover-noarrow"
                  v-if="AUTH_DEVICE_DELETE || AUTH_DEVICE_ENABLE_DISABLE"
                >
                  <template slot="content">
                    <ul class="g-ellipsis-menu">
                      <li
                        @click="enableDevice(record)"
                        v-if="record.disable && AUTH_DEVICE_ENABLE_DISABLE"
                      >
                        <ins><a-icon type="play-circle"/></ins>
                        <span>{{ $t('com_btn_enabled2') }}</span>
                      </li>

                      <li
                        @click="disabledDevice(record)"
                        v-if="!record.disable && AUTH_DEVICE_ENABLE_DISABLE"
                      >
                        <ins><Icon type="forbidden2"/></ins>
                        <span>{{ $t('com_btn_disabled2') }}</span>
                      </li>

                      <li
                        @click="deleteDevice(record)"
                        v-if="AUTH_DEVICE_DELETE"
                        style="color:red;"
                      >
                        <ins> <Icon type="delete"/></ins>
                        <span>{{ $t('com_btn_delete') }}</span>
                      </li>
                    </ul>
                  </template>
                  <a-button type="primary" class="ant-btn-ellipsis">
                    <Icon type="ellipsis" />
                  </a-button>
                </a-popover>
              </div>
            </template>
          </a-table>
        </div>
      </div>

      <Empty v-else />
    </div>

    <!-- 批量导入设备 -->
    <a-modal
      v-model="showImport"
      :title="$t('device_table_import')"
      @ok="handleImport"
      @cancel="() => (showImport = false)"
      centered
      v-if="showImport && AUTH_SITE_DETAIL_DEVICE_BATCH_IMPORT"
      :confirmLoading="importLoading"
      width="60%"
    >
      <div class="device-import-description">
        <p>{{ $t('device_table_import_description') }}</p>
        <p>
          <a href="/template/device_import_sample.xlsx" download>
            {{ $t('device_table_import_download') }}
          </a>
        </p>
      </div>

      <a-form-model
        :model="importForm"
        :rules="importRules"
        ref="importUploadFile"
        layout="vertical"
      >
        <!-- model -->
        <a-form-model-item
          :label="$t('device_search_model_label')"
          prop="devModelName"
          :extra="$t('device_form_model_extra')"
        >
          <a-input
            v-model="importForm.devModelName"
            :placeholder="$t('device_form_select_model_placeholder')"
            readOnly
            @click="pickDeviceModel"
          >
            <template slot="suffix">
              <a-icon type="down" />
            </template>
          </a-input>
        </a-form-model-item>

        <!-- 编辑模式，不允许重新上传 -->
        <a-form-model-item
          :label="$t('com_upload_select_file')"
          prop="file"
          style="margin-bottom: 0;"
        >
          <UploadOSS
            :value="importForm.file"
            :manuallyUpload="true"
            @selected="handleUploadFile"
            :maxCount="1"
            ref="uploadFile"
            uploadDirInOSS="attachment"
            uploadType="file"
            :acceptFileSize="1024 * 1024 * 1024"
            :acceptFileTypes="['.xls', '.xlsx']"
          />
        </a-form-model-item>
      </a-form-model>
      <!-- 错误 -->
      <div class="device-import-error" v-if="importError.sns.length || importError.names.length">
        <a-alert
          :message="$t('device_form_import_batch_failed')"
          type="error"
          show-icon
          style="margin-bottom: 10px;"
        />
        <p v-if="importError.names.length">
          <label>{{ $t('device_form_import_name_error') }}：</label>
          {{ importError.names.join(', ') }}
        </p>
        <p v-if="importError.sns.length">
          <label>{{ $t('device_form_import_sns_error') }}：</label>
          {{ importError.sns.join(', ') }}
        </p>
      </div>

      <!-- 预览 -->
      <a-table
        :columns="importPreviewColumns"
        :data-source="importFormData.devices"
        :pagination="false"
        :rowKey="(text, index) => index"
        bordered
        size="small"
        v-if="importFormData && importFormData.devices && importFormData.devices.length"
      >
        <!-- 时间 -->
        <template slot="arrivalDate" slot-scope="text">
          {{ text | formatDate('yyyy-MM-dd') }}
        </template>

        <template slot="installDate" slot-scope="text">
          {{ text | formatDate('yyyy-MM-dd') }}
        </template>
      </a-table>

      <!-- SelectModel -->
      <SelectModel ref="selectModel" :callback="getDevModeId" />
    </a-modal>
  </div>
</template>
<script>
import { trim, calculateDuration, makeTree, readExcelData } from '@/libs/utils';
import { SiteDevices } from '@/api/site';
import DeviceStatus from '@/views/device/components/status';
import moment from 'moment';
import DeviceOperation from '@/mixins/device-operation';
import siteAuth from '@/views/site/mixins/siteAuth';
import deviceAuth from '@/views/device/mixins/deviceAuth';
import SelectModel from '@/views/device/components/selectModel';
import * as ModelAPI from '@/api/system/model';
import { DeviceImportBatch } from '@/api/device';
import modelMixin from '@/mixins/model';

export default {
  mixins: [DeviceOperation, siteAuth, deviceAuth, modelMixin],
  components: { DeviceStatus, SelectModel },
  props: {
    // 站点信息
    siteData: {
      type: Object,
      default: () => ({}),
    },
    // 站点Id
    stationId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      calculateDuration,
      moment,
      listType: 'card',

      // 设备列表
      deviceList: null,
      deviceListSource: null,

      // 列表
      columns: [
        {
          title: this.$t('device_table_name'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'Name' },
        },

        {
          title: this.$t('device_table_status'),
          dataIndex: 'workStatus',
          scopedSlots: { customRender: 'Status' },
        },

        {
          title: this.$t('device_table_total_runtime'),
          dataIndex: 'totaltime',
          customRender: (text, record) => {
            return calculateDuration({
              time: record.instDate,
              showDay: true,
              showHour: false,
              showMin: false,
            });
          },
        },

        {
          title: this.$t('device_table_unmaintained_time'),
          dataIndex: 'maintenanceUpdtTime',
          customRender: (text, record) => {
            return calculateDuration({
              time: record.maintenanceUpdtTime,
              showDay: true,
              showHour: false,
              showMin: false,
            });
          },
        },

        {
          title: this.$t('device_table_sn'),
          dataIndex: 'devSn',
          scopedSlots: { customRender: 'devSn' },
        },

        {
          title: this.$t('device_table_model'),
          dataIndex: 'modelName',
          scopedSlots: { customRender: 'modelName' },
        },

        {
          title: this.$t('device_table_soft_version'),
          dataIndex: 'versionInfo',
          scopedSlots: { customRender: 'versionInfo' },
        },

        {
          title: this.$t('device_table_install_date'),
          dataIndex: 'instDate',
          scopedSlots: { customRender: 'InstDate' },
          sorter: (a, b) => {
            // 按时间戳排序（instDate是时间戳或可被Date解析的格式）
            return new Date(a.instDate).getTime() - new Date(b.instDate).getTime();
          },
        },

        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'Action' },
        },
      ],

      loading: false,

      // 搜索关键字
      searchKeyword: '',

      // 批量导入设备
      showImport: false,

      importForm: {
        devModelName: undefined,
        file: undefined,
      },
      importError: {
        names: [],
        sns: [],
      },
      importFormData: {
        devices: [],
        stationId: this.stationId,
        devModelId: undefined,
      },
      importLoading: false,

      importRules: {
        devModelName: [
          {
            required: true,
            message: this.$t('device_form_select_model_placeholder'),
            trigger: 'change',
          },
        ],
        file: [
          {
            required: true,
            message: this.$t('device_table_import_message'),
            trigger: 'change',
          },
        ],
      },

      importPreviewColumns: [
        {
          title: '#',
          align: 'center',
          customRender: (text, record, index) => {
            return index + 1;
          },
        },
        {
          title: this.$t('device_table_name'),
          dataIndex: 'name',
        },

        {
          title: this.$t('device_table_sn'),
          dataIndex: 'sn',
        },

        {
          title: this.$t('device_base_info_arrival_date'),
          dataIndex: 'arrivalDate',
          scopedSlots: { customRender: 'arrivalDate' },
        },

        {
          title: this.$t('device_table_install_date'),
          dataIndex: 'installDate',
          scopedSlots: { customRender: 'installDate' },
        },

        {
          title: this.$t('com_form_remark'),
          dataIndex: 'remark',
        },
      ],

      // model list
      // 批量导入的时候选择model的时候用
      modelList: {},
    };
  },
  created() {
    if (this.AUTH_SITE_DETAIL_DEVICE_BATCH_IMPORT) {
      this.getData();
    } else {
      this.getDeviceList(true);
    }
  },
  methods: {
    // 获取表单数据
    getData() {
      const _list = [this.getModelList(), this.getDeviceList(true)];

      this.loading = true;
      Promise.all(_list).finally(() => {
        // 全部接口返回时，清除loading
        this.$store.commit('setPageLoading', false);
        this.loading = false;
      });
    },

    // 选择Model
    pickDeviceModel() {
      this.$refs.selectModel.show(this.modelList, this.importForm.devModelId);

      this.importError = {
        names: [],
        sns: [],
      };
    },

    // 获取model id
    getDevModeId(model) {
      if (model) {
        this.importForm.devModelName = model.name || model.title;

        this.importFormData.devModelId = model.devModelId;
      }
    },

    // 上传文件
    handleUploadFile(files) {
      this.importError = {
        names: [],
        sns: [],
      };

      this.importForm.file = files;
      this.readData(files);
    },

    // 获取model list
    getModelList() {
      return ModelAPI.DeviceModelListAll().then(res => {
        try {
          const treeObj = makeTree({
            data: res.data || [],
            idName: 'devModelId',
            parentIdName: 'parentId',
            deleteIcon: false,
          });

          this.modelList = treeObj;
        } catch (err) {
          console.log('err', err);
        }
      });
    },

    // 切换列表类型
    listTypeHandle(value) {
      this.listType = value;
    },

    // 获取设备列表
    getDeviceList() {
      const params = {
        stationId: this.stationId,
      };

      // 去掉关键字两边的空格
      if (params.query) {
        params.query = trim(params.query);
        this.form.query = params.query;
      }
      this.loading = true;

      return SiteDevices(params)
        .then(res => {
          if (res.code === 0) {
            // 获取设备列表的ids
            const devModelIds = (res.data || []).map(item => item.devModelId);

            this.getModelAlias(devModelIds, () => {
              // 如果list已经获取到，则更新list
              //更新 list数据的值，把别名赋值给list
              if (
                this.deviceList &&
                this.deviceList.length > 0 &&
                Object.keys(this.modelAliasObject).length > 0
              ) {
                this.deviceList.forEach((item, index) => {
                  if (this.modelAliasObject[item.devModelId]) {
                    const newItem = {
                      ...item,
                      devModelAliasName: this.modelAliasObject[item.devModelId],
                    };
                    this.$set(this.deviceList, index, newItem);
                  }
                });
              }
            });

            this.deviceList = res.data || [];
            this.deviceListSource = res.data || [];
          }
        })
        .catch(err => {
          if (!/cancelled/gi.test(err)) {
            this.networkError = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 搜索（前端过滤）
    filterDevicesByName() {
      const _keyword = trim(this.searchKeyword);

      this.deviceList = (this.deviceListSource || []).filter(
        device =>
          device?.name?.toLowerCase().includes(_keyword.toLowerCase()) ||
          device?.devSn?.toLowerCase().includes(_keyword.toLowerCase()) ||
          device?.versionInfo?.toLowerCase().includes(_keyword.toLowerCase())
      );
    },

    // 维护弹窗
    handleMaintenance(currentDevice) {
      this.maintenanceDeviceInMixins({
        params: {
          devId: currentDevice.devId,
          maintenanceUpdtTime: new Date().getTime(),
        },
        devName: currentDevice.name,
        callback: () => {
          // 重新获取列表
          this.getDeviceList();
        },
      });
    },

    // 删除设备
    deleteDevice(currentDevice) {
      this.deleteDeviceInMixins({
        params: { devId: currentDevice.devId },
        devName: currentDevice.name,
        callback: () => {
          // 重新获取列表
          this.getDeviceList();
        },
      });
    },

    // 禁用设备
    disabledDevice(currentDevice) {
      this.disabledDeviceInMixins({
        params: {
          devId: currentDevice.devId,
        },
        devName: currentDevice.name,
        callback: () => {
          currentDevice.disable = true;
          // 重新获取列表
          this.getDeviceList();
        },
      });
    },

    // 启用设备
    enableDevice(currentDevice) {
      this.enableDeviceInMixins({
        params: { devId: currentDevice.devId },
        devName: currentDevice.name,
        callback: () => {
          currentDevice.disable = false;

          // 重新获取列表
          this.getDeviceList();
        },
      });
    },

    // 导入设备
    handleImport() {
      try {
        this.$refs.importUploadFile.validate(valid => {
          if (valid) {
            if (
              !(
                this.importFormData &&
                this.importFormData.stationId &&
                this.importFormData.devModelId &&
                this.importFormData.devices &&
                this.importFormData.devices.length
              )
            ) {
              this.$message.error(this.$t('device_form_import_batch_error'));
              return false;
            }

            this.importLoading = true;
            DeviceImportBatch(this.importFormData)
              .then(res => {
                if (res.code === 0) {
                  this.importError = {
                    names: [],
                    sns: [],
                  };
                  // 只有data.result为true时，才表示导入成功
                  if (!res.data.result) {
                    // names
                    this.importError.names = res.data.names || [];
                    // sns
                    this.importError.sns = res.data.sns || [];

                    this.$message.error(
                      res.data.message || this.$t('device_form_import_batch_failed')
                    );
                    return false;
                  }

                  this.$refs.importUploadFile.resetFields();
                  this.importForm = {
                    devModelName: undefined,
                    file: undefined,
                  }; // success
                  this.$message.success(this.$t('device_form_import_batch_success'));

                  // 重新获取列表
                  this.getDeviceList();

                  this.showImport = false;
                }
              })
              .catch(err => {
                console.error(this.$t('device_form_import_batch_failed'), err);
                this.$message.error(this.$t('device_form_import_batch_failed'));
              })
              .finally(() => {
                this.importLoading = false;
              });
          } else {
            console.error('Form valid error', valid);
            return false;
          }
        });
      } catch (err) {
        console.error(err);
      }
    },

    // 读取文件
    readData(files) {
      if (!files || !files.length) {
        console.log('No file selected');
        return;
      }
      const self = this;
      const file = files[0];
      if (file) {
        readExcelData(file.originFileObj || file, ['ArrivalDate', 'InstallDate'], function(data) {
          const _form = [];
          // 组装数据
          data.forEach(item => {
            _form.push({
              arrivalDate: new Date(item.ArrivalDate).getTime(),
              installDate: new Date(item.InstallDate).getTime(),
              name: item.DeviceName,
              remark: item.Remark,
              sn: item.SN,
            });
          });

          self.importFormData.devices = _form;
        });
      }
    },

    // 重置搜索
    resetSearch() {
      this.searchKeyword = '';
      this.filterDevicesByName();
      this.getDeviceList();
    },
  },
};
</script>
<style lang="less" scoped>
.site-device-main {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  overflow-y: auto;
  .site-device-action {
    background: @g-layout-background;

    .site-device-action-content {
      display: flex;
      justify-content: space-between;
      width: 100%;
      background: #fff;
      height: 88px;
      padding: 24px;
      border-radius: 12px;
      margin-bottom: 16px;
      align-items: center;
      gap: 8px;

      // 搜索排序
      ::v-deep .site-device-search {
        display: flex;
        button {
          margin-left: 12px;
        }

        input {
          width: 500px;
        }
      }

      // 排序
      .site-device-sort {
        display: flex;
        align-items: center;
        height: 40px;
        span {
          cursor: pointer;
          font-size: 20px;
          background: #fff;
          padding: 0 16px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: rgba(0, 0, 0, 0.45);

          &.active {
            color: @primary-color !important;
            border: @primary-color solid 1px !important;
          }

          &:first-child {
            border-radius: 6px 0 0 6px;
            border: 1px solid rgba(0, 0, 0, 0.15);
          }

          &:last-child {
            border-radius: 0 6px 6px 0;
            border: 1px solid rgba(0, 0, 0, 0.15);
            border-left: none;
          }

          &:hover {
            color: @primary-color;
          }
        }
      }
    }
  }

  // 内容
  .site-device-content {
    background: #fff;
    box-shadow: 0 -12px 0 0 @g-layout-background;
    border-radius: 12px;
    flex: 1;
    padding: 24px;
    padding-right: 8px;

    .site-device-content-title {
      display: flex;
      align-items: center;
      justify-items: flex-start;

      a,
      button {
        display: flex;
        align-items: center;
      }
    }

    // 卡片模式
    .site-device-content-card {
      display: flex;
      grid-gap: 16px;
      padding-top: 16px;
      width: 100%;
      flex-wrap: wrap;

      li {
        width: calc(20% - 16px);
        border-radius: 6px;
        border: 1px solid #eee;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .card-title {
          line-height: 24px;
          color: rgba(0, 0, 0, 0.88);
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 8px;
          padding: 24px 24px 0 24px;

          a {
            color: rgba(0, 0, 0, 0.88);
            text-decoration: none;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            display: block;
            width: 100%;

            &:hover {
              color: @primary-color;
            }
          }
        }

        .card-content {
          padding: 0 24px 16px 24px;
          .card-content-time {
            display: flex;
            justify-content: space-between;
            gap: 8px;
            margin: 0;
            text-align: center;

            dd {
              color: rgba(0, 0, 0, 0.45);
              font-size: 14px;
              height: 80px;
              width: 50%;
              border-radius: 12px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              strong {
                font-size: 24px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
              }
              span {
                color: #18181a;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
              }

              &:first-child {
                background: #f6ffed;
                strong {
                  color: #52c41a;
                }
              }

              &:last-child {
                background: #fffbe6;
                strong {
                  color: #faad14;
                }
              }
            }
          }
          p {
            padding: 0;
            margin: 0 0 8px 0;
            color: #18181a;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            display: flex;
            label {
              white-space: nowrap;
            }
            span {
              word-wrap: break-word;
              word-break: break-all;
            }
          }
        }

        .card-action {
          padding: 8px 0;
          border-top: #eee solid 1px;
          dl {
            display: flex;
            justify-content: space-between;
            margin: 0;
            padding: 0;

            dd {
              cursor: pointer;
              font-size: 16px;
              transition: all 0.3s;
              border-right: solid 1px rgba(0, 0, 0, 0.06);
              flex: 1;
              height: 38px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin: 0;

              &:last-child {
                border-right: none;
              }

              a {
                display: flex;
                width: 100%;
                align-items: center;
                justify-content: center;
                color: #000;
                cursor: pointer;
                height: 100%;

                svg {
                  width: 24px;
                  height: 24px;
                  opacity: 0.45;
                }

                &:hover {
                  color: @primary-color;
                  svg.icon {
                    color: @primary-color;
                  }
                }
              }
            }
          }
        }

        &:hover {
          box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);
        }
      }
    }

    // 列表模式
    .site-device-content-list {
      padding-top: 16px;

      .device-list-name {
        display: flex;
        align-items: center;

        .device-list-name-icon {
          margin-right: 4px;
          width: 18px;
          height: 18px;

          svg {
            width: 100%;
            height: 100%;
          }
        }

        .device-list-name-link {
          flex: 1;
          word-wrap: break-word;
          word-break: break-all;
        }
      }

      .site-device-action {
        display: flex;
        background: none;
        padding: 0;
        margin: 0;
        height: auto;

        button {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}

// 导入
.device-import-description {
  display: flex;
  justify-content: space-between;
  padding-bottom: 15px;
}

.device-import-error {
  // 淡红色
  border: #e91e1e52 solid 1px;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
}
</style>
